import {Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ProgressOverlayComponent} from './progress-overlay/progress-overlay.component';

@Injectable()
export class ProgressService {
    private modalRef: NgbModalRef | undefined;

    constructor(
        private modal: NgbModal,
    ) {
    }

    start(): void {
        if (!this.modalRef) {
            this.modalRef = this.modal.open(ProgressOverlayComponent, {
                size: 'sm',
                windowClass: 'progress-overlay',
                ariaLabelledBy: 'loading'
            });
            console.debug('Progress spinner started');
        } else {
            console.debug('start spinner called but another spinner is still working');
        }
    }

    stop(): void {
        if (this.modalRef) {
            console.debug('spinner stopped');
            this.modalRef.close();
            delete this.modalRef;
        } else {
            console.debug('stop spinner called but no spinner found');
        }
    }
}
